import { listAvailablePages } from '../pages/page-catalog';
import { loadGrantedPermissions } from '../pages/user-permissions';
import { AgentTool, AgentToolResult } from './agent-tool.types';
import { WsToolDeclaration } from '../ws/agent-ws.types';

/**
 * Каталог внутренних страниц для блока `link`, уже отфильтрованный по правам.
 */
export class AgentAppPagesTool implements AgentTool {
    /** @inheritdoc */
    public readonly declaration: WsToolDeclaration = {
        toolName: 'get_app_pages',
        description:
            'Возвращает все внутренние страницы приложения, которые текущий пользователь может открыть блоком link. '
            + 'Страницы сгруппированы по категориям и уже отфильтрованы по правам — не предлагай страницы вне ответа. '
            + 'ОБЯЗАТЕЛЬНО вызови этот инструмент ПЕРЕД сборкой блока link и подставляй в route только path из ответа как есть, включая /core и #hash. Не выдумывай URL. '
            + 'Используй каталог для навигации, а не для получения статуса, дат, сумм или состава документа. '
            + 'Для вопросов об открытом документе используй контекст страницы и данные документа; не заменяй ответ общей ссылкой. '
            + 'Плейсхолдер {ID} замени на числовой id сущности; если {ID} встречается дважды — слева направо: родитель, затем дочерняя сущность. '
            + 'Не пиши ссылку в тексте сообщения, если можно показать блок link. '
            + 'Для отфильтрованного реестра заявок или счетов используй get_registry_filters и блок registry_link, а не link. '
            + 'Категория «ЭДО (legacy)» — старый ЭДО Синтеки, маршруты рабочие. '
            + 'Основными ссылками, которые представляют общую информацию о сущности являются отчеты (report) или карточки сущности.',
        requestFormat: {},
        responseFormat: {
            categories: 'array of { title, pages: array of { name, path } }',
        },
    };

    private readonly getGrantedPermissions: () => Promise<ReadonlySet<string>>;

    public constructor(
        getGrantedPermissions: () => Promise<ReadonlySet<string>> = loadGrantedPermissions,
    ) {
        this.getGrantedPermissions = getGrantedPermissions;
    }

    /** @inheritdoc */
    public async execute(_args: Record<string, unknown>): Promise<AgentToolResult> {
        try {
            const granted = await this.getGrantedPermissions();

            return {
                ok: true,
                payload: { categories: listAvailablePages(granted) },
            };
        } catch (error) {
            console.error('Failed to load permissions for get_app_pages:', error);

            return {
                ok: false,
                error: {
                    code: 'permissions_unavailable',
                    message: 'Не удалось получить права пользователя. Не собирай блок link без маршрута из get_app_pages.',
                },
            };
        }
    }
}
